import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmarkLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 19.246094,6.4296875 c -0.0996,8.2e-4 -0.197563,0.021277 -0.289063,0.060547 -0.0915,0.03926 -0.17494,0.096369 -0.24414,0.1679687 L 9.6132813,15.757813 5.7675781,11.914063 c -0.1415198,-0.1366 -0.3306939,-0.212738 -0.5273437,-0.210938 -0.1966498,0.0018 -0.3844477,0.0816 -0.5234375,0.220703 -0.1389899,0.1391 -0.21714,0.326838 -0.21875,0.523438 -0.00162,0.196699 0.072294,0.385944 0.2089843,0.527343 l 4.3750001,4.375 c 0.06951,0.0698 0.1531907,0.12441 0.2441406,0.16211 0.09095,0.0378 0.1886294,0.05859 0.2871094,0.05859 0.1971498,-0.0013 0.3862707,-0.081 0.5253907,-0.220703 L 19.773437,7.71875 c 0.0716,-0.06915 0.128669,-0.1506976 0.167969,-0.2421875 0.0394,-0.09148 0.05965,-0.1894826 0.06055,-0.2890625 0.001,-0.09959 -0.01699,-0.1988257 -0.05469,-0.2910156 -0.0376,-0.09219 -0.09366,-0.1756438 -0.164063,-0.2460938 -0.0703,-0.07046 -0.153894,-0.1263025 -0.246094,-0.1640625 -0.0922,-0.03775 -0.191415,-0.057461 -0.291015,-0.056641 z"
	})]
});
export default SvgCheckmarkLine;
